<app-card [showHeader]="true" [cardTitle]="title" padding="25">
  <ng-template #headerOptionsTemplate>
    <a class="avatar avatar-s modal-close" mat-dialog-close>
      <i class="ti ti-x f-20"></i>
    </a>
  </ng-template>
  <query-builder
    [(ngModel)]="query"
    [classNames]="bootstrapClassNames"
    [config]="currentConfig"
    [allowRuleset]="allowRuleset"
    [allowCollapse]="allowCollapse"
    [persistValueOnFieldChange]="persistValueOnFieldChange"
  >
    <div class="col-auto" *queryInput="let rule; type: 'textarea'">
      <textarea class="form-control" [(ngModel)]="rule.value" placeholder="Custom Textarea"></textarea>
    </div>
  </query-builder>
  <ng-template #actionTemplate>
    <div class="buttons">
      <button mat-stroked-button (click)="clearData()">
        <span> {{ 'clear' | translate }} </span>
      </button>
      <button mat-flat-button color="primary" mat-dialog-close (click)="applyFilter()" [disabled]="query.rules.length == 0">
        <span> {{ 'search' | translate }} </span>
      </button>
    </div>
  </ng-template>
</app-card>
